import { useEffect } from 'react';
import { createTranslatorHook } from '@nps.today/translations';
import { translator as translatorDanish } from './generated/da';
import { translator as translatorEnglish } from './generated/en';
import type { ITranslator } from './generated/translationInterface';

const useBaseTranslator = createTranslatorHook<ITranslator>(
  { da: translatorDanish, en: translatorEnglish },
  'en'
);

export let translator: ITranslator | undefined;

export const useTranslator = (): ITranslator => {
  const current = useBaseTranslator();
  useEffect(() => {
    translator = current;
  }, [current]);
  return current;
};
